<div class="p-8 rounded flex flex-col items-start justify-between gap-6">
  @if (!dontShowAgainFlag) {
    <span class="text-[15px] font-medium text-color-normal">{{ title }}</span>
  }
  @if (dontShowAgainFlag) {
    <span class="text-[15px] font-medium text-color-normal ml-[11px]">{{ title }}</span>
  }

  <mat-dialog-content class="pr-1 pt-1 pb-1 pl-0 w-[400px]">
    @if (!dontShowAgainFlag) {
      <p class="text-color-secondary text-sm mt-0 mb-2">{{ message }}</p>
    }
    @if (dontShowAgainFlag) {
      <p class="text-color-secondary text-sm mt-0 mb-2 ml-[11px]">{{ message }}</p>
    }
    @if (dontShowAgainFlag) {
      <mat-checkbox class="text-sm text-color-secondary m-0" [(ngModel)]="dontShowAgain">
        {{ 'CONFIRM_DIALOG.DONT_SHOW_AGAIN' | translate }}
      </mat-checkbox>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="flex items-center gap-3 justify-end w-full p-0 min-h-0">
    @for (button of buttons; track $index) {
      @if (!button.primary) {
        <button
          type="button"
          mat-button
          (click)="onButtonClick(button)"
          class="px-4 py-2 bg-white rounded text-color-primary border border-color-light-shade border-solid h-10 w-20 font-medium text-sm font-['Roboto'] cursor-pointer"
        >
          {{ button.text }}
        </button>
      }
      @if (button.primary) {
        <button
          type="button"
          mat-button
          (click)="onButtonClick(button)"
          class="px-4 py-2 bg-color-primary rounded text-white border-none h-10 w-20 font-medium text-sm font-['Roboto'] cursor-pointer"
        >
          {{ button.text }}
        </button>
      }
    }
  </mat-dialog-actions>
</div>
